import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-400">深度策划的专题内容，带你全面了解热门话题</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden aspect-[2/1] cursor-pointer"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 text-xs font-bold bg-accent-500 text-background-50 rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-black text-white mb-2 group-hover:text-accent-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-white/70 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}